import React, { memo, forwardRef } from 'react'
import AutoSizer from 'react-virtualized-auto-sizer'
import { FixedSizeGrid, areEqual } from 'react-window'
import ProductCard from './ProductCard'

const PADDING_SIZE = 30

// eslint-disable-next-line
const innerElementType = forwardRef(({ style, ...rest }, ref) => (
  <div
    ref={ref}
    style={{
      ...style,
      height: `${parseFloat(style.height) + PADDING_SIZE * 3.5}px`
    }}
    {...rest}
  />
))

function getColumnProps(width) {
  if (width < 600) {
    return [width - 20, 1]
  }

  if (width < 920) {
    return [(width - 20) / 2, 2]
  }

  if (width < 1300) {
    return [(width - 100) / 2, 2]
  }

  return [400, 3]
}

function StoreProductsGrid({ products, language, onProductClick, classes }) {
  // eslint-disable-next-line
  const Row = memo(({ columnCount, columnIndex, rowIndex, style }) => {
    const index = rowIndex === 0 ? columnIndex : rowIndex * columnCount + columnIndex
    const product = products[index]

    if (!product) return null

    return (
      <div
        style={{
          ...style,
          top: `${parseFloat(style.top) + PADDING_SIZE}px`,
          padding: 12
        }}
      >
        <ProductCard
          product={product}
          language={language}
          classes={classes}
          onProductClick={onProductClick}
        />
      </div>
    )
  }, areEqual)

  return (
    <AutoSizer>
      {({ height, width }) => {
        const [columnWidth, columnCount] = getColumnProps(width)

        return (
          <FixedSizeGrid
            columnWidth={columnWidth}
            columnCount={columnCount}
            height={height}
            rowCount={
              Number.isInteger(products.length / columnCount)
                ? products.length / columnCount
                : Math.ceil(products.length / columnCount)
            }
            innerElementType={innerElementType}
            rowHeight={132}
            width={width}
          >
            {(selfProps) => <Row {...selfProps} columnCount={columnCount} />}
          </FixedSizeGrid>
        )
      }}
    </AutoSizer>
  )
}

export default memo(StoreProductsGrid)
